import { render, staticRenderFns } from "./ProductType.vue?vue&type=template&id=e0760518"
import script from "./ProductType.vue?vue&type=script&lang=js"
export * from "./ProductType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports